import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-pdftool',
    imports: [],
    templateUrl: './pdftool.component.html',
    styleUrl: './pdftool.component.css'
})
export class PdftoolComponent {
  @Output() iconSelected = new EventEmitter<string>();

  onIconClick(iconidentifire: string) {
    this.iconSelected.emit(iconidentifire);
  }
}
